import cx from 'clsx';
import React, { PropsWithChildren } from 'react';

import styles from './BasicScroll.module.scss';

const BasicScroll = ({ children }: PropsWithChildren) => {
  return <div className={cx(styles.container)}>{children}</div>;
};

export default BasicScroll;
